import { render, staticRenderFns } from "./DetailsField.vue?vue&type=template&id=396813ce&scoped=true"
import script from "./DetailsField.vue?vue&type=script&lang=js"
export * from "./DetailsField.vue?vue&type=script&lang=js"
import style0 from "./DetailsField.vue?vue&type=style&index=0&id=396813ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396813ce",
  null
  
)

export default component.exports